import axios from 'axios';

import { Holiday } from 'components/types';

import { PUBLIC_HOLIDAYS } from 'RestAPIs/endpoints';

export const getHolidays = () => axios.get<Holiday[]>(PUBLIC_HOLIDAYS);
